<template>
  <div id='app'>
        <div v-show="loading" class="loader">
      <p>Now loading...
      <v-progress-circular
      indeterminate
      color="primary"
    ></v-progress-circular>
      </p>
    </div>
    <div v-show="!loading" >
    <v-toolbar flat color="white">
      <v-toolbar-title data-app>宛先管理 </v-toolbar-title>
      <v-divider
        class="mx-5"
        inset
        vertical
      ></v-divider>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" max-width="600px">
        <template v-slot:activator="{ on }">
          <v-btn color="primary" dark class="mb-2" v-on="on">追加</v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 >
                  <v-text-field v-model="editedItem.companyName" label="企業名"></v-text-field>
                </v-flex>
                <v-flex xs12 >
                  <v-text-field v-model="editedItem.staffName" label="担当者名"></v-text-field>
                </v-flex>
                <v-flex xs12 >
                  <v-text-field v-model="editedItem.mail" label="メールアドレス"></v-text-field>
                </v-flex>
                <v-flex xs12 >
                  <v-text-field v-model="editedItem.note" label="備考"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close">キャンセル</v-btn>
            <v-btn color="blue darken-1" flat @click="save">更新</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="destinations"
      rows-per-page-text=""
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td>{{ props.item.companyName }}</td>
        <td class="text-xs-left">{{ props.item.staffName }}</td>
        <td class="text-xs-left">{{ props.item.mail }}</td>
        <td class="text-xs-left">{{ props.item.note }}</td>
        <td class="text-xs-left">
          <v-icon
            medium
            class="mr-2"
            @click="editItem(props.item)"
          >
            edit
          </v-icon>
          <v-icon
            medium
            @click="deleteItem(props.item)"
          >
            delete
          </v-icon>
        </td>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
  </div>
  </div>
</template>

<script>
import axios from 'axios'
import store from '@/store.js'

  export default {
    data: () => ({
      dialog: false,
      headers: [
        {
          text: '企業名',
          align: 'left',
          sortable: false,
          value: 'companyName'
        },
        { text: '担当者名', value: 'name' },
        { text: 'メールアドレス', value: 'mail' },
        { text: '備考', value: 'note' },
        { text: '編集・削除', value: 'name', sortable: false }
      ],
      destinations: [],
      editedIndex: -1,
      editedItem: {
        companyName:'',
        staffName: '',
        mail: '',
        note: ''
      },
      defaultItem: {
        companyName:'',
        staffName: '',
        mail: '',
        note: ''
      },
      loading: true
    }),
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? '追加' : '編集'
      }
    },
    watch: {
      dialog (val) {
        val || this.close()
      }
    },
    created () {
    const self = this
        axios
          .get(
            'https://a6ecsge4pk.execute-api.ap-northeast-1.amazonaws.com/RECRUITMENT_SEND/master/destination/list',
            {headers:{'Authorization':sessionStorage.getItem('Authorization')}}
          )
          .then(response => {
            self.destinations = response.data
            this.loading = false
            console.log(response.data)
          })
          .catch(function(error) {
            console.log(error)
          })
    },
    methods: {
      initialize (){

      },
      editItem (item) {
        this.editedIndex = this.destinations.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },
      deleteItem (item) {
        const self = this
        const index = this.destinations.indexOf(item)
        console.log(self.destinations[index].mail)
        confirm('このデータを削除してもよろしいですか？') &&
        //DBから削除
        axios.delete(
        'https://a6ecsge4pk.execute-api.ap-northeast-1.amazonaws.com/RECRUITMENT_SEND/master/destination/content',
        {
           params: {
             mail: self.destinations[index].mail
             },
           headers:{
            'Authorization':sessionStorage.getItem('Authorization')
           }
        },
          
      )
      .then(function(response) {
        //削除できたとき
        self.destinations.splice(index, 1)
        this.loading = false
      })
      .catch(function(error) {
        console.log(error)
      })
      },
      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },
      save () {
        if (this.editedIndex > -1) {
          const self = this
          Object.assign(this.destinations[this.editedIndex], this.editedItem)
          console.log(self.destinations[self.editedIndex].companyName)
          //DBに保存する通信
           axios.post(
           'https://a6ecsge4pk.execute-api.ap-northeast-1.amazonaws.com/RECRUITMENT_SEND/master/destination/content ',
           {
            mail: self.destinations[self.editedIndex].mail,
            companyName: self.destinations[self.editedIndex].companyName,
            staffName: self.destinations[self.editedIndex].staffName, 
            note: self.destinations[self.editedIndex].note
           },
           {
            headers:{
              'Authorization':sessionStorage.getItem('Authorization')
            }
           }
          )
            .then(function(response) {
             //更新できたとき
             this.loading = false
            console.log(response.data)
            })
          .catch(function(error) {
            console.log(error)
          })
            } else {
              this.destinations.push(this.editedItem)
              console.log(this.editedItem)
              const self = this
              axios
              .post(
                'https://a6ecsge4pk.execute-api.ap-northeast-1.amazonaws.com/RECRUITMENT_SEND/master/destination/content ',
                   {
                     mail: self.editedItem.mail,
                      companyName: self.editedItem.companyName,
                     staffName: self.editedItem.staffName, 
                      note: self.editedItem.note
                    },
                  {
                    headers:{
                      'Authorization':sessionStorage.getItem('Authorization')
                    }
                  }
      )
      .then(function(response) {
        //登録できたとき
        this.loading = false
        console.log(response.data)
      })
      .catch(function(error) {
        console.log(error)
      })
        }
        this.close()
      },
    }
  }
</script>

<style scoped>
p {
  text-align: center;
  font-size: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Management.vue